import { Box } from "@mui/material";
import imageManifest from "../../generated/imageManifest.json";

function buildSrcSet(variants = []) {
    return variants.map((variant) => `${variant.path} ${variant.width}w`).join(", ");
}

function getFallbackImage(imageData) {
    return (
        imageData?.formats?.jpg?.[imageData.formats.jpg.length - 1]?.path ||
        imageData?.formats?.webp?.[imageData.formats.webp.length - 1]?.path ||
        imageData?.formats?.avif?.[imageData.formats.avif.length - 1]?.path ||
        ""
    );
}

function OptimizedImage({
                            imageKey,
                            alt,
                            sizes = "100vw",
                            loading = "lazy",
                            priority = false,
                            sx,
                            imgSx,
                            objectFit = "cover",
                            objectPosition = "center",
                        }) {
    const imageData = imageManifest[imageKey];

    if (!imageData) {
        console.warn(`Bild nicht im Manifest gefunden: ${imageKey}`);
        return null;
    }

    const fallbackSrc = getFallbackImage(imageData);

    return (
        <Box
            sx={{
                position: "relative",
                overflow: "hidden",
                backgroundColor: "#f7f1e8",
                ...sx,
            }}
        >
            {imageData.blurDataURL && (
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        backgroundImage: `url(${imageData.blurDataURL})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        filter: "blur(12px)",
                        transform: "scale(1.08)",
                    }}
                />
            )}

            <picture>
                {imageData.formats?.avif?.length > 0 && (
                    <source
                        type="image/avif"
                        srcSet={buildSrcSet(imageData.formats.avif)}
                        sizes={sizes}
                    />
                )}

                {imageData.formats?.webp?.length > 0 && (
                    <source
                        type="image/webp"
                        srcSet={buildSrcSet(imageData.formats.webp)}
                        sizes={sizes}
                    />
                )}

                <Box
                    component="img"
                    src={fallbackSrc}
                    alt={alt}
                    width={imageData.width}
                    height={imageData.height}
                    loading={priority ? "eager" : loading}
                    decoding={priority ? "sync" : "async"}
                    fetchPriority={priority ? "high" : "auto"}
                    sx={{
                        position: "relative",
                        zIndex: 1,
                        width: "100%",
                        height: "100%",
                        display: "block",
                        objectFit,
                        objectPosition,
                        ...imgSx,
                    }}
                />
            </picture>
        </Box>
    );
}

export default OptimizedImage;